import { AnimatedParam } from '../../lmv-compat/tools/ViewTransition';

export class AnimatedVisibility {
	container;
	showStyle;
	param;

	constructor(container, initValue, animTime = 0.5, showStyle = 'block') {
		// Note: we could add a hint on `will-change` opacity if we see performance issues.
		this.container = container;
		this.showStyle = showStyle;
		this.param = new AnimatedParam(Number(initValue), (a) => setOpacity(this.container, a), animTime);
	}

	async turnOff() {
		return new Promise((resolve) => this.param.fadeTo(0.0, resolve));
	}

	/**
	 * Animates the change in visibility of the container.
	 * Note: If you keep skipping animation, create and use an immediate visibility class instead.
	 * @param {number|boolean} visibility Either {true, false} or the final opacity value [0.0, 1.0]
	 * @param {boolean} skipAnimation If present, set the value immediately.
	 */
	async set(visibility, skipAnimation) {
		const fractionVisible = Number(visibility);
		const endsVisible = fractionVisible > 0;

		if (this.valueOf()) {
			if (endsVisible) {
				// don't animate opacity changes while visible.
				this.param.setValue(fractionVisible);
			} else {
				if (skipAnimation) {
					this.param.setValue(0.0);
				} else {
					return new Promise((resolve) => this.param.fadeTo(0.0, resolve));
				}
			}
		} else {
			if (endsVisible) {
				this.container.style.display = this.showStyle;
				this.param.curValue = 1E-6; // for valueOf before the first frame of `fadeTo`.
				if (skipAnimation) {
					this.param.setValue(fractionVisible);
				} else {
					return new Promise((resolve) => this.param.fadeTo(fractionVisible, resolve));
				}
			} else {
				// NOOP from hidden to hidden
			}
		}
	}

	/** Immediate visibility */
	valueOf() {
		return this.param.curValue > 0;
	}

	/** Eventual visibility, in case it's different from immediate (when animating) */
	targetValue() {
		const animating = this.param.fadeAnim?.isRunning;
		return animating ? this.param.targetValue > 0 : this.valueOf();
	}
}

function setOpacity(container, a) {
	if (a > 0 && a < 1) {
		container.style.opacity = a;
		return;
	}

	// unset if either fully visible or invisible, display style will take over.
	container.style.removeProperty('opacity');
	// If visible, then we pre-set the display style no need to change.
	if (a === 0) container.style.display = 'none';
}
